import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import AthleteReminderList from "./AthleteReminderList";
import Delete from "./DeleteModal";
import MoreInfoModal from "./MoreInfoModal";

const Card = (props) => {
  const [athleteOpen, setAthleteOpen] = useState(false);
  const [secondOpen, setSecondOpen] = useState(false);
  const [confirm, setConfirm] = useState(null);

  return (
    <>
      <div className="eventDetails-data event-page-card reminder-admin-card">
        <div className="card-body">
          <div className="user-content">
            <div className="title">
              <h4 onClick={() => setSecondOpen(true)}>
                {props.reminder?.title}
              </h4>
              <div className="remind-buttons">
                <Button
                  circular
                  color="blue"
                  content={
                    props.reminder?.athletes?.length
                      ? props.reminder?.athletes?.length < 10
                        ? `0${props.reminder?.athletes?.length}`
                        : props.reminder?.athletes?.length
                      : "list"
                  }
                  onClick={() => setAthleteOpen(true)}
                />
                {/* <Button circular color="green" icon="edit" /> */}
                <Button
                  circular
                  color="red"
                  icon="trash"
                  onClick={() => setConfirm(props.reminder.id)}
                />
              </div>
            </div>
            <p>{props.reminder?.content}</p>
          </div>
        </div>
      </div>
      <AthleteReminderList
        athletes={props.reminder?.athletes}
        open={athleteOpen}
        close={() => setAthleteOpen(false)}
      />
      <MoreInfoModal
        open={secondOpen}
        reminder={props.reminder}
        close={() => setSecondOpen(false)}
      />
      <Delete
        open={confirm}
        close={() => setConfirm(null)}
        deleteId={confirm}
      />
    </>
  );
};

export default Card;
